import * as React from 'react';
import { CircleNumber, Text } from '.';
import { textalign } from '../services/app.service';

interface Props {
  id?: string;
  data: any;
  start?: number;
  size?: number;
  spacing?: number;
  textAlign?: textalign
  disableNumber?: boolean;
}

export const Numbering: React.FunctionComponent<Props> = (props) => {
  
  return (
    <>
      {props.data?.map((d: any, i: number) => {
        const label = props.disableNumber? (props.start || 1) + i : undefined;
        return (
            <Text key={i} textAlign={props.textAlign} sx={{display: 'flex', marginBottom: props.spacing || 2}}>
                <CircleNumber color='primary.light' size={props.size} label={label}/>
                <Text label={d} />
            </Text>
        )
      })}
    </>
  );
  
}
